import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard, NonInfluencerGuard } from '@app/_guards';
import { DashboardComponent } from './dashboard.component';

/**
 * Must be imported first in AppModule so this pathMatch:full route wins over
 * eagerly loaded feature modules that also register path: ''.
 */
const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: DashboardComponent,
    canActivate: [AuthGuard, NonInfluencerGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DashboardRoutingModule {}
